import { DepositLimitCalculatorAction } from "./deposit-limit-calculator.action";

export const CACHE_STORE_DEPOSIT_LIMIT_CALCULATOR = "mat.ui.common.responsible-gaming.deposit-limit-calculator";
export const DEPOSIT_LIMIT_CALCULATOR_PREDICTIONS_KEY = "depositLimitCalculatorPredictions";

export const DEPOSIT_LIMIT_CALCULATOR_MESSAGE_CONTEXT = {
	getPredictions: DepositLimitCalculatorAction.getPredictions.type,
};

export enum DepositLimitCalculatorMethods {
	Amount = "amount",
	Date = "date",
	Time = "time",
}
export enum DepositLimitPeriods {
	Daily = "daily",
	Weekly = "weekly",
	Monthly = "monthly",
}

// an array of hour,minute and second strings: ["16:00","17:00",...];
export const HOURS_OF_THE_DAY = [...Array(24).keys()].map((key) => `${key.toString().padStart(2, "0")}:00`);

export const DEPOSIT_LIMIT_CALCULATOR_TRANSLATION_PREFIX = "deposit-limit-calculator";
export const DEFAULT_MAX_DEPOSIT_LIMIT = 0;
